import classNames from 'classnames';
import React from 'react';

type Props = {
  children?: React.ReactNode,
  className?: string
};

class Page extends React.Component<Props> {
  override render (): React.ReactNode {
    const { children, className } = this.props;

    return (
      <div className={classNames('esko_fullpagecontainer', className)}>
        {children}
      </div>
    );
  }
}

export default Page;
